import { useState } from "react";
import { Save, KeyRound } from "lucide-react";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AdminAccount() {
  const { user } = useAuth();
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [msg, setMsg] = useState({ type: "", text: "" });
  const [saving, setSaving] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setMsg({ type: "", text: "" });
    if (form.new_password.length < 8) return setMsg({ type: "error", text: "La nueva contraseña debe tener al menos 8 caracteres." });
    if (form.new_password !== form.confirm) return setMsg({ type: "error", text: "Las contraseñas no coinciden." });
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: form.current_password, new_password: form.new_password });
      setMsg({ type: "ok", text: "Contraseña actualizada correctamente." });
      setForm({ current_password: "", new_password: "", confirm: "" });
    } catch (err) {
      setMsg({ type: "error", text: formatErr(err.response?.data?.detail) || "Error al cambiar contraseña." });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="admin-account">
      <h1 className="font-display text-4xl font-black tracking-tighter mb-1">Mi cuenta</h1>
      <p className="text-sm text-muted-foreground mb-8">Sesión actual: <strong>{user?.email}</strong></p>

      <form onSubmit={submit} className="max-w-xl border border-border rounded-sm p-6 lg:p-8 space-y-5" data-testid="change-password-form">
        <div className="flex items-center gap-2 mb-2">
          <KeyRound className="w-5 h-5 text-primary" />
          <h2 className="font-display font-bold text-xl">Cambiar contraseña</h2>
        </div>

        <Field label="Contraseña actual" type="password" required value={form.current_password} onChange={set("current_password")} testid="current-password" />
        <Field label="Nueva contraseña" type="password" required value={form.new_password} onChange={set("new_password")} testid="new-password" />
        <Field label="Confirmar nueva contraseña" type="password" required value={form.confirm} onChange={set("confirm")} testid="confirm-password" />

        {msg.text && (
          <p className={`text-sm ${msg.type === "ok" ? "text-primary" : "text-destructive"}`} data-testid="account-message">
            {msg.text}
          </p>
        )}

        <button type="submit" disabled={saving} data-testid="submit-change-password" className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary text-primary-foreground font-semibold rounded-sm hover:opacity-90 disabled:opacity-50">
          <Save className="w-4 h-4" /> {saving ? "Guardando..." : "Actualizar contraseña"}
        </button>
      </form>
    </div>
  );
}

function Field({ label, testid, ...props }) {
  return (
    <div>
      <label className="text-xs uppercase tracking-widest font-bold mb-1.5 block">{label}</label>
      <input data-testid={testid} {...props} className="w-full h-11 px-4 bg-background border border-border rounded-sm focus:border-primary outline-none text-sm" />
    </div>
  );
}
